import { useMemo } from 'react'
import { useTheme, ThemeProvider, createTheme } from '@mui/material'
import { useAppContext } from 'GlobalContext'
import { useShadowRoot } from 'ShadowContext'

export function TemaProvider({ container, children }) {
  const temaEsistente = useTheme()
  const { uri } = useAppContext()
  const shadowRoot = useShadowRoot()

  const tema = useMemo(
    () =>
      createTheme(temaEsistente, {
        ...(themes?.[uri] ?? {}),
        typography: {
          fontFamily: '"Titillium Web", Arial, sans-serif',
        },
        components: {
          ...(themes?.[uri]?.components ?? {}),
          MuiModal: {
            defaultProps: { container: shadowRoot },
          },
          MuiPopover: {
            defaultProps: { container: shadowRoot },
          },
          MuiPopper: {
            defaultProps: { container: shadowRoot },
          },
          MuiDialog: {
            defaultProps: { container: shadowRoot },
          },          
        },
      }),
    [uri, shadowRoot]
  )

  return <ThemeProvider theme={tema}>{children}</ThemeProvider>
}

const themes = {
  cuneo: {
    palette: {
      primary: { main: "#660200" },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            '&.MuiButton-containedPrimary': {
              '&:hover': {
                backgroundColor: '#530100',
              },
            },
          }
        },
      },
    },
  },
}